import React from 'react';

import { EntityResults } from './EntityResults';
import { useGetEntitiesForUser } from './hooks/useGetEntitiesForUser';
import { EntityTypeFilterType } from './types';

type AccessResultsProps = {
  filter: EntityTypeFilterType;
  onSelect?: () => void;
};
const AccessResults = ({ filter, onSelect }: AccessResultsProps) => {
  const { brands, draftVenues, enterprises, isLoading, merchants, venues } = useGetEntitiesForUser();

  return (
    <EntityResults
      draftVenues={draftVenues}
      enterprises={enterprises}
      isLoading={isLoading}
      merchants={merchants}
      venues={venues}
      brands={brands}
      filter={filter}
      onSelect={onSelect}
    />
  );
};

export default AccessResults;
